import { useQuery } from "@apollo/client";
import { GET_SCHOOLS } from "./MapOverviewTrafficLite.queries";

export const useSchools = (clientLoginId, options = {}) => {
  const { enabled = true } = options;

  const { data, loading, error, refetch } = useQuery(GET_SCHOOLS, {
    variables: {
      clientLoginId,
    },
    skip: !clientLoginId || !enabled,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
  });

  const schools = data?.getLtmAois || [];
  
  console.log('🟣 useSchools - loading:', loading, 'error:', error, 'schools:', schools?.length);

  return {
    schools,
    loading,
    error,
    refetch,
  };
};
